import {Asset} from '../Assets.types';
import {AssetType, DerivedFilePurpose} from '../Assets.enums';
import getDerivedFileUrl from './getDerivedFileUrl';

/**
 * Gets the appropriate file URL for copying/sharing/using in UI.
 * For video assets, returns mid-quality video URL (or original as fallback).
 * For other assets, returns original URL.
 */
export default function getAssetUrlLink(asset: Asset): string {
  const originalUrl = asset.originalfile.fileUrl || '';

  if (asset.assetType === AssetType.Video) {
    return getDerivedFileUrl(asset, DerivedFilePurpose.HighQualityVideo);
  }

  if (asset.assetType === AssetType.AnimatedImage) {
    return getDerivedFileUrl(asset, DerivedFilePurpose.AnimatedImageAsImage);
  }

  if (asset.assetType === AssetType.Image) {
    return getDerivedFileUrl(asset, DerivedFilePurpose.CompressedImage);
  }

  return originalUrl;
}
